import PropTypes from 'prop-types';
import React, { useState, useEffect } from 'react';

import {DebounceInput} from 'react-debounce-input';

const axios = require('axios').default;
import { toast } from 'react-toastify';
import AsyncSelect from 'react-select/async';
import { components } from 'react-select';

import ArtistChipsField from '../../shared/components/ArtistChipsField';
import {
  EVENTS_MENU_ITEM
} from '../constants/editTourConstants';

const selectStyles = {
  container: (base, state) => ({
    ...base,
    opacity: state.isDisabled ? ".5" : "1",
    backgroundColor: "transparent",
    zIndex: "999"
  }),
  control: (base, state) => ({
    ...base,
    border: '1px solid #D5D7DA',
    borderRadius: '8px',
    padding: '2px 3px',
    boxShadow: 'none'
  }),
  menuPortal: base => ({ ...base, zIndex: 9999 }),
  menu: provided => ({ ...provided, zIndex: "9999 !important" })
};

const Option = (props) => {
  const { data } = props;
  return (
    <components.Option {...props}>
      <div style={{ display: 'flex', alignItems: 'center', padding: '8px' }}>
        {data.image_thumb_url && (
          <img
            src={data.image_thumb_url}
            alt={data.label}
            style={{
              width: '24px',
              height: '24px',
              borderRadius: '50%',
              marginRight: '8px',
              objectFit: 'cover',
              flexShrink: 0
            }}
          />
        )}
        <span style={{
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          maxWidth: '300px'
        }}>{data.label}</span>
      </div>
    </components.Option>
  );
};

const SingleValue = (props) => {
  const { data } = props;
  return (
    <components.SingleValue {...props}>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        {data.image_thumb_url && (
          <img
            src={data.image_thumb_url}
            alt={data.label}
            style={{
              width: '24px',
              height: '24px',
              borderRadius: '50%',
              marginRight: '8px',
              objectFit: 'cover',
              flexShrink: 0
            }}
          />
        )}
        <span style={{
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          maxWidth: '300px'
        }}>{data.label}</span>
      </div>
    </components.SingleValue>
  );
};

const TourDetails = ({
  csrfToken,
  team,
  currentUser,
  tour,
  tourChanged,
  setActiveTab
}) => {
  const [supportArtists, setSupportArtists] = useState([]);

  useEffect(() => {
    if (tour.support_performers && tour.support_performers.length > 0) {
      setSupportArtists(tour.support_performers.map(performer => ({
        value: performer.artistable.id,
        label: performer.artistable.name,
        image_thumb_url: performer.artistable.image_thumb_url,
        performer_id: performer.id
      })));
    } else {
      setSupportArtists([]);
    }
  }, [tour.support_performers, tour.id]);

  const canCreateTour = (
    tour
      && tour.name
      && tour.name.length > 0
      && tour.artist_ownership
      && tour.artist_ownership.value
  );

  const debouncedFetchArtistOwnerships = _.debounce((team, inputValue, callback) => {
    new Promise(resolve => {
      axios.get(`/teams/${team.id}/artist_ownerships`, {
          params: {
            q: {
              artistable_of_Artist_type_name_cont: inputValue
            }
          }
        })
        .then(({data}) => {
          callback(data)
        })
    });
  }, 250);

  const createTour = (tour) => {
    const supportPerformersAttributes = supportArtists
      .filter(artist => artist && artist.value)
      .map(artist => ({
        artistable_id: artist.value,
        artistable_type: 'Artist',
        act_type: 'support'
      }));

    axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken;
    axios.post(`/teams/${team.id}/tours`, {
        tour: {
          name: tour.name,
          artist_ownership_id: tour.artist_ownership.value,
          support_performers_attributes: supportPerformersAttributes
        }
      })
      .then(({data}) => {
        window.history.pushState({}, '', `/teams/${team.id}/tours/${data.id}/edit`);

        tourChanged(data);
        setActiveTab(EVENTS_MENU_ITEM);
      })
      .catch((error) => {
        toast.error(error.response.data.join(", "), {
          position: toast.POSITION.TOP_CENTER,
          draggable: false,
          closeOnClick: false,
          autoClose: 5000,
          hideProgressBar: true
        });
      });
  };

  const autoSaveTour = (tour, updatedSupportArtists = null) => {
    if (!tour.id) {
      return false;
    }

    const artistsToUse = updatedSupportArtists || supportArtists;
    const supportPerformersAttributes = artistsToUse
      .filter(artist => artist && artist.value)
      .map((artist) => {
        const attributes = {
          artistable_id: artist.value,
          artistable_type: 'Artist',
          act_type: 'support'
        };

        if (artist.performer_id) {
          attributes.id = artist.performer_id;
        }

        return attributes;
      });

    if (tour.support_performers) {
      const currentArtistIds = artistsToUse.map(a => a && a.performer_id).filter(Boolean);
      tour.support_performers.forEach((performer) => {
        if (!currentArtistIds.includes(performer.id)) {
          supportPerformersAttributes.push({
            id: performer.id,
            _destroy: true
          });
        }
      });
    }

      axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken;
  axios.put(`/teams/${team.id}/tours/${tour.id}`, {
      tour: {
        name: tour.name,
        artist_ownership_id: tour.artist_ownership.value,
        support_performers_attributes: supportPerformersAttributes
      }
    })
    .then(({data}) => {
      tourChanged(data);
    })
    .catch((error) => {
      toast.error(error.response.data.join(", "), {
        position: toast.POSITION.TOP_CENTER,
        draggable: false,
        closeOnClick: false,
        autoClose: 5000,
        hideProgressBar: true
      });
    });
  };

  const supportArtistsChanged = (updated) => {
    setSupportArtists(updated);
    if (tour.id) {
      autoSaveTour(tour, updated);
    }
  };

  return (
    <div>
      <form onSubmit={(e) => {
              e.preventDefault();
              e.stopPropagation();

              if (!canCreateTour) {
                return false;
              }

              createTour(tour);
            }}>
        <div className="form-row" style={{marginBottom: '20px'}}>
          <div className="col-12 col-md-4">
            <label htmlFor="tour-name"
                  style={{
                    fontSize: '14px',
                    fontWeight: '600',
                  }}>
              Tour name<span style={{color: "#1982C4"}}>*</span>
            </label>
          </div>
          <div className="col-12 col-md-8">
            <DebounceInput type="text"
                    className="form-control"
                    debounceTimeout={250}
                    style={{
                      "border": "1px solid #D5D7DA",
                    }}
                    value={tour.name || ""}
                    onChange={
                      (e) => {
                        var tourName = e.target.value;

                        if(tour && tour.id && tourName.length === 0) {
                          tourName = tour.artist_ownership.label;
                        }

                        var updated = {...tour, name: tourName};

                        tourChanged(updated)
                        autoSaveTour(updated)
                      }
                    }
                    id="tour-name" />
          </div>
        </div>
        <div className="form-row" style={{marginBottom: '20px'}}>
          <div className="col-12 col-md-4">
            <label htmlFor="tour-artist-ownership-id"
                  style={{
                    fontSize: '14px',
                    fontWeight: '600',
                  }}>
              Artist<span style={{color: "#1982C4"}}>*</span>
            </label>
          </div>
          <div className="col-12 col-md-8">
            <AsyncSelect
              cacheOptions
              styles={selectStyles}
              menuPortalTarget={document.querySelector('body')}
              defaultOptions
              id="tour-artist-ownership-id"
              value={tour.artist_ownership}
              loadOptions={(inputValue, callback) => debouncedFetchArtistOwnerships(team, inputValue, callback)}
              onChange={(option) => {
                var updated = {...tour, artist_ownership: option};

                tourChanged(updated)
                autoSaveTour(updated)
              }}
              components={{ Option, SingleValue }}
            />
          </div>
        </div>
        <div className="form-row" style={{marginBottom: '20px'}}>
          <div className="col-12 col-md-4">
            <label style={{
                fontSize: '14px',
                fontWeight: '600',
              }}>
              Support <i className="fa fa-question-circle" 
                        style={{color: '#6c757d', marginLeft: '4px'}} 
                        title="Add support artists for this tour"></i>
            </label>
          </div>
          <div className="col-12 col-md-8">
            <ArtistChipsField
              id="tour-support-artists"
              value={supportArtists}
              addLabel="Add support artist"
              teamId={team.id}
              onChange={supportArtistsChanged}
            />
          </div>
        </div>
        <div className="form-row"
              style={{
                margin: '35px 0px 20px 0px'
              }}>
          <div className="col-12 text-right">
            {tour.id ? (
              <a href="#"
                  className='btn btn-primary'
                  style={{fontSize: '14px'}}
                  onClick={(e) => {
                    e.preventDefault();
                    setActiveTab(EVENTS_MENU_ITEM);
                  }}>
                Continue
              </a>
            ) : (
              <button type="submit"
                  disabled={!canCreateTour}
                  style={{fontSize: '14px'}}
                  className="btn btn-primary">
                Continue
              </button>
            )}
          </div>
        </div>
      </form>
    </div>
  )
};

TourDetails.propTypes = {
  csrfToken: PropTypes.string.isRequired,
  team: PropTypes.object.isRequired,
  currentUser: PropTypes.object.isRequired,
  tour: PropTypes.object.isRequired,
  tourChanged: PropTypes.func.isRequired,
  setActiveTab: PropTypes.func.isRequired
};

export default TourDetails;
